// extracted by mini-css-extract-plugin
export default {"rowPt":"register-password_rowPt__Nnq-3","Background":"register-password_Background__vdapN"};